import { render, staticRenderFns } from "./MobileHeader.vue?vue&type=template&id=58f84b3e&scoped=true"
import script from "./MobileHeader.vue?vue&type=script&lang=ts"
export * from "./MobileHeader.vue?vue&type=script&lang=ts"
import style0 from "./MobileHeader.vue?vue&type=style&index=0&id=58f84b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f84b3e",
  null
  
)

export default component.exports